import { TEAMVIEW_APPLICATIONS_LAYOUT_COLS, CUSTOMERVIEW_APPLICATIONS_LAYOUT_COLS } from '@funnels/constants';

export const WINDOW_RESIZE_DEBOUNCE_DELAY = 500;
export const CARD_BREAKPOINT_SIZES = {
  xs: 4,
  sm: 4,
  md: 4,
  lg: 4,
  xl: 3,
};

export const TEAMVIEW_CARD_BREAKPOINT_SIZE = {
  xs: 4 / TEAMVIEW_APPLICATIONS_LAYOUT_COLS.xs,
  sm: 4 / TEAMVIEW_APPLICATIONS_LAYOUT_COLS.sm,
  md: 4 / TEAMVIEW_APPLICATIONS_LAYOUT_COLS.md,
  lg: 4 / TEAMVIEW_APPLICATIONS_LAYOUT_COLS.lg,
  xl: 3 / TEAMVIEW_APPLICATIONS_LAYOUT_COLS.xl,
};

export const CUSTOMERVIEW_CARD_BREAKPOINT_SIZE = {
  xs: 4 / CUSTOMERVIEW_APPLICATIONS_LAYOUT_COLS.xs,
  sm: 4 / CUSTOMERVIEW_APPLICATIONS_LAYOUT_COLS.sm,
  md: 4 / CUSTOMERVIEW_APPLICATIONS_LAYOUT_COLS.md,
  lg: 4 / CUSTOMERVIEW_APPLICATIONS_LAYOUT_COLS.lg,
  xl: 3 / CUSTOMERVIEW_APPLICATIONS_LAYOUT_COLS.xl,
};

export const SUMMARY_UNIT_DESKTOP_SIZE_LARGE = 12 / TEAMVIEW_APPLICATIONS_LAYOUT_COLS.xl;
export const SUMMARY_UNIT_DESKTOP_SIZE_SMALL = 9 / TEAMVIEW_APPLICATIONS_LAYOUT_COLS.xl;
